const routes = [
    {
        path: "/dual/enrollment/agreement-form",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "student_enrollmentagreement"
        }
    }
];

export default routes;
